import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getCrops(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CROPS,
		ModulesConfigMap[ModulesMap.CROPS].GET_CROPS,
		options
	)
}

function _getCropPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CROPS,
		ModulesConfigMap[ModulesMap.CROPS].GET_CROP_PREVIEW,
		options
	)
}

function _getCropPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CROPS,
		ModulesConfigMap[ModulesMap.CROPS].GET_CROP_POPUP,
		options
	)
}

function _createCrop(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CROPS,
		ModulesConfigMap[ModulesMap.CROPS].CREATE_CROP,
		options
	)
}

function _getCrop(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CROPS,
		ModulesConfigMap[ModulesMap.CROPS].GET_CROP,
		options
	)
}

function _patchCrop(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CROPS,
		ModulesConfigMap[ModulesMap.CROPS].PATCH_CROP,
		options
	)
}

function _putCrop(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CROPS,
		ModulesConfigMap[ModulesMap.CROPS].PUT_CROP,
		options
	)
}

function _deleteCrop(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CROPS,
		ModulesConfigMap[ModulesMap.CROPS].DELETE_CROP,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.CROPS].GET_CROPS]:
		_getCrops,

	[ModulesConfigMap[ModulesMap.CROPS].GET_CROP_PREVIEW]:
		_getCropPreview,
	[ModulesConfigMap[ModulesMap.CROPS].GET_CROP_POPUP]:
		_getCropPopup,

	[ModulesConfigMap[ModulesMap.CROPS].CREATE_CROP]: _createCrop,
	[ModulesConfigMap[ModulesMap.CROPS].GET_CROP]: _getCrop,
	[ModulesConfigMap[ModulesMap.CROPS].PATCH_CROP]: _patchCrop,
	[ModulesConfigMap[ModulesMap.CROPS].PUT_CROP]: _putCrop,
	[ModulesConfigMap[ModulesMap.CROPS].DELETE_CROP]: _deleteCrop,
}
